// Tax-year time (w9-plan T5, T20): a W-9 files under the calendar year it
// is signed in, in America/New_York. The dashboard reads "today" in that
// zone so the current year, the current month and the chart's "Through
// Oct 23" agree with what the server stamps.

const ZONE = 'America/New_York';

export const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

// { year, month (0-11), day } for `now` in Eastern time.
export const etParts = (now = new Date()) => {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: ZONE,
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  }).formatToParts(now);
  const read = (type) => {
    const hit = parts.find((p) => p.type === type);
    return hit ? Number(hit.value) : 0;
  };
  return { year: read('year'), month: read('month') - 1, day: read('day') };
};

export const currentTaxYear = (now) => etParts(now).year;

// "Oct 23"
export const etShortDate = (now) => {
  const { month, day } = etParts(now);
  return `${MONTHS[month]} ${day}`;
};

// IRS record-keeping guidance: keep a W-9 four years past its tax year.
export const keepThrough = (year) => Number(year) + 4;

// The year to show for a ?year= value: 'all', a number, or the current
// year when the URL has none. Any number is accepted (a year with no
// rows still renders, with zero counts).
export const resolveYear = (param, current) => {
  if (param === 'all') return 'all';
  return Number(param) > 0 ? Number(param) : current;
};
